<template>
  <div>
    <swiper ref="mySwiper" :options="swiperOptions" circular>
      <swiper-slide v-for="(item, index) in originList" :key="index">
        <div
          class="swiper-zoom-container"
          v-if="index - current < 3 && -2 < index - current"
        >
          <img :src="item" />
          <!-- <div class="swiper-lazy-preloader swiper-lazy-preloader-black"></div> -->
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
export default {
  data() {
    return {
      originList: [
        require("../assets/image/0-1.jpg"),

        require("../assets/image/1-1.jpg"),
        require("../assets/image/1-2.jpg"),
        require("../assets/image/2-1.jpg"),
        require("../assets/image/2-2.jpg"),
        require("../assets/image/3-1.jpg"),
        require("../assets/image/3-2.jpg"),
        require("../assets/image/4-1.jpg"),
        require("../assets/image/4-2.jpg"),
        require("../assets/image/5-1.jpg"),
        require("../assets/image/5-2.jpg"),
        require("../assets/image/6-1.jpg"),
        require("../assets/image/6-2.jpg"),
        require("../assets/image/7-1.jpg"),
        require("../assets/image/7-2.jpg"),
        require("../assets/image/8-1.jpg"),
        require("../assets/image/8-2.jpg"),
        require("../assets/image/9-1.jpg"),
        require("../assets/image/9-2.jpg"),
        require("../assets/image/10-1.jpg"),
        require("../assets/image/10-2.jpg"),
        require("../assets/image/11-1.jpg"),
        require("../assets/image/11-2.jpg"),
        require("../assets/image/12-1.jpg"),
        require("../assets/image/12-2.jpg"),
        require("../assets/image/13-1.jpg"),
        require("../assets/image/13-2.jpg"),
        require("../assets/image/14-1.jpg"),
        require("../assets/image/14-2.jpg"),
        require("../assets/image/15-1.jpg"),
        require("../assets/image/15-2.jpg"),
        require("../assets/image/16-1.jpg"),
        require("../assets/image/16-2.jpg"),
        require("../assets/image/17-1.jpg"),
        require("../assets/image/17-2.jpg"),
        require("../assets/image/18-1.jpg"),
        require("../assets/image/18-2.jpg"),
        require("../assets/image/19-1.jpg"),
        require("../assets/image/19-2.jpg"),
        require("../assets/image/20-1.jpg"),
        require("../assets/image/20-2.jpg"),
        require("../assets/image/21-1.jpg"),
        require("../assets/image/21-2.jpg"),
        require("../assets/image/0-2.jpg"),
      ],
      displaySwiperList: [], // swiper需要的数据
      displayIndex: 0, // 用于显示swiper的真正的下标数值只有：0，1，2。
      originIndex: 0, // 记录源数据的下标
      current: 0,
      swiperOptions: {
        // lazy: true,
        zoom: true,
        speed: 500,
        on: {
          slideChangeTransitionEnd: (event) => {
            let swiper = this.$refs.mySwiper.swiper;
            let current = swiper.activeIndex;
            this.current = current;
          },
        },
      },
    };
  },
  methods: {},
  mounted() {
    document.title = "索贝十周年杂志";
  },
};
</script>

<style lang='scss' scoped>
.swiper-container {
  width: 100vw;
  height: 100vh;
  .swiper-slide {
    position: relative;
    display: flex;
    align-content: center;
    justify-content: center;
    img {
      // max-width: 100%;
      // max-height: 100%;
      // display: block;
      image-rendering: -moz-pixelated;
      image-rendering: -o-pixelated;
      image-rendering: -webkit-pixelated;
      image-rendering: pixelated;
      // -ms-interpolation-mode: nearest-neighbor;
    }
  }
}
.box {
  width: 100vw;
  height: 100vh;
}
</style>